export default __webpack_public_path__ + "fonts/Roboto-300-latin-ext6.woff2";